import { apiFilesBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class LayoutImageComponentAPI {

    constructor() {
        this.baseUrl = new URL("layoutimagecomponent/", apiFilesBaseURL);
    }

    create(image) {
        return API.authenticatedRequest({
            url: this.baseUrl,
            method: HTTPMethod.POST,
            contentType: ContentType.MULTIPART,
            token: authenticationCentral.accessToken,
            body: image
        });
    }

    list() {
        return API.authenticatedRequest({
            url: this.baseUrl,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    delete(imageId) {
        return API.authenticatedRequest({
            url: new URL(imageId, this.baseUrl),
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
